import * as m from "mithril";
import * as dayjs from 'dayjs';
import { MessageProvider } from "../context/AppMessages";
import './MiniTripItineraryView.css';
import { getIntlStringValue } from "../helpers/StringHelpers";
import { TripDTO, WayPointScheduleDTO } from "../apiclient/ApiDtos";

export default function MiniTripItineraryView(): m.Component<{
  messageProvider: MessageProvider,
  trip: TripDTO,
  size: 'small' | 'medium',
  fill: boolean
}> {
  return {

    view(vnode) {
      let trip = vnode.attrs.trip;
      let messageProvider = vnode.attrs.messageProvider;
      let currLang = messageProvider.getCurrentLang();
      let condensed = vnode.attrs.size == 'small';

      let hasDifferentOrigin = trip.origin ? trip.origin.location.id != trip.departure.location.id : false;
      let hasDifferentOriginDate = hasDifferentOrigin ?
        dayjs(trip.origin.scheduledAt).day() != dayjs(trip.departure.scheduledAt).day() : false;

      let itineraryMoreClass = "itinerary-md text-body-md";
      const scheduleTimeFormat = "MMM D, hh:mm A";
      if (condensed) {
        itineraryMoreClass = "itinerary-sm text-body-sm";
      }

      return [
        m("div.itinerary " + itineraryMoreClass, [

          (hasDifferentOrigin) ? m(MiniTripItineraryItemView, {
            messageProvider: messageProvider,
            waypoint: trip.origin,
            condensed: condensed,
            disabled: true,
            fill: vnode.attrs.fill,
            type: 'departure-origin',
            scheduleDescription: condensed ? vnode.attrs.messageProvider.get("trip.starts_at", {
              time: dayjs(trip.origin.scheduledAt).format(scheduleTimeFormat)
            }) : dayjs(trip.origin.scheduledAt).format(scheduleTimeFormat)
          }) : null,

          m(MiniTripItineraryItemView, {
            messageProvider: messageProvider,
            waypoint: trip.departure,
            condensed: condensed,
            disabled: false,
            fill: vnode.attrs.fill,
            type: hasDifferentOrigin ? 'departure-non-origin' : 'departure-origin',
            scheduleDescription: condensed ? vnode.attrs.messageProvider.get("trip.departs_at", {
              time: dayjs(trip.departure.scheduledAt).format(scheduleTimeFormat)
            }) : dayjs(trip.departure.scheduledAt).format(scheduleTimeFormat)
          }),

          m(MiniTripItineraryItemView, {
            messageProvider: messageProvider,
            waypoint: trip.arrival,
            condensed: condensed,
            disabled: false,
            fill: vnode.attrs.fill,
            type: 'arrival',
            scheduleDescription: condensed ? vnode.attrs.messageProvider.get("trip.arrives_at", {
              time: dayjs(trip.arrival.scheduledAt).format(scheduleTimeFormat)
            }) : dayjs(trip.arrival.scheduledAt).format(scheduleTimeFormat)
          })

        ]),

        (condensed == false) ?
          m("div.mt-2", [
            m("small.important-info-alert2", vnode.attrs.messageProvider.get("trip.notice_estimated_arrival")),
            m("sup.text-danger", "*")
          ]) : null,

      ];
    }
  }
}

function MiniTripItineraryItemView(): m.Component<{
  messageProvider: MessageProvider,
  waypoint: WayPointScheduleDTO,
  disabled: boolean,
  condensed: boolean,
  fill: boolean,
  type: 'departure-origin' | 'departure-non-origin' | 'arrival',
  scheduleDescription: string
}> {
  return {
    view(vnode) {
      let condensed = vnode.attrs.condensed

      let waypoint = vnode.attrs.waypoint;
      let currLang = vnode.attrs.messageProvider.getCurrentLang();

      let edgeTopClass = "edge-top";
      let edgeBotClass = "edge-bot";
      let waypointInactive = ""

      if (vnode.attrs.type == 'departure-origin') {
        if (vnode.attrs.disabled) {
          edgeTopClass = "edge-top";
          edgeBotClass = "edge-bot edge-inactive";
          //waypointInactive = "waypoint-inactive";
        } else {
          edgeTopClass = "edge-top";
          edgeBotClass = "edge-bot edge-active";
        }

      } else if (vnode.attrs.type == 'departure-non-origin') {
        edgeTopClass = "edge-top edge-inactive"
        edgeBotClass = "edge-bot edge-active";
      } else if (vnode.attrs.type == 'arrival') {
        edgeTopClass = "edge-top edge-active"
        edgeBotClass = "edge-bot";
      }

      let nodeClass = "node-active";
      if (vnode.attrs.disabled) {
        nodeClass = "node-inactive";
      }

      let scheduleClass = "waypoint-schedule";
      if (vnode.attrs.fill) {
        scheduleClass = "waypoint-schedule text-right";
      }

      return [
        m("div.waypoint-figure", [
          m("." + edgeTopClass),
          m("." + nodeClass),
          m("." + edgeBotClass)
        ]),
        m("div.waypoint-name ", {
          class: waypointInactive
        }
          ,
          getIntlStringValue(waypoint.location.name, currLang)
        ),
        m("." + scheduleClass, {
          class: waypointInactive
        },
          vnode.attrs.scheduleDescription
        )
      ]
    }
  }
}